
const defaultOptions = {
	enable: false,
	findScrollElement: (element) => document.scrollingElement || document.body,
	getStickTop: (element) => 0,
	fixStickBox: box => box,
}

/**
 * @returns {DraftEditorPlugin}
 */
export function createStickToolbarPlugin(options = defaultOptions) {
	const {
		enable,
		findScrollElement,
		getStickTop,
		fixStickBox,
	} = { ...defaultOptions, ...options };

	if (!enable) {
		return {};
	}

	/** @type {Element} */
	let scrollElement = null;
	/** @type {HTMLDivElement} */
	let toolbarElement = null;
	let stickOffset = 0;

	/** @type {Function} */
	let checkStick = () => {
		if (!scrollElement || !toolbarElement) {
			return;
		}
		const stickTop = getStickTop(scrollElement);
		const { top, left, width, height } = fixStickBox(
			toolbarElement.parentElement.getBoundingClientRect()
		);
		const right = left + width;
		const bottom = top + height;
		if (bottom < stickTop) {
			toolbarElement.style.display = 'none';
		}
		else if (top < stickTop) {
			toolbarElement.style.display = 'block';
			toolbarElement.style.position = 'fixed';
			toolbarElement.style.top = stickTop + 'px';
			toolbarElement.style.left = left + 'px';
			toolbarElement.style.width = width + 'px';
		}
		else {
			toolbarElement.style.display = 'block';
			toolbarElement.style.position = 'absolute';
			toolbarElement.style.top = 0;
			toolbarElement.style.left = 0;
			toolbarElement.style.width = '100%';
		}
	};

	return {
		getToolbarWidgets: () => [{
			onToolbarMount(toolbar) {
				toolbarElement = toolbar.element;
				scrollElement = findScrollElement(toolbarElement);
				if (scrollElement) {
					scrollElement.addEventListener('scroll', checkStick);
					window.addEventListener('resize', checkStick);
				}
				else {
					console.warn('findScrollElement() 返回空，工具栏吸顶功能不可用')
				}
			},
			onToolbarUnmount(toolbar) {
				if (scrollElement) {
					scrollElement.removeEventListener('scroll', checkStick);
				}
				window.removeEventListener('resize', checkStick);
			},
		}]
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/stickToolbarPlugin/createStickToolbarPlugin.js